<hb-base-widget
  [dashboardWidget]="dashboardWidget"
  [title]="title"
  [sortable]="sortable"
  [showActions]="showActions"
  [showDataOption]="true"
  [widgetTableData]="dashboardWidget?.widget?.data?.TableData"
>
  <div class="widget-chart-container px-2">
    <canvas baseChart class="chart" [id]="canvasId" chartType="line"></canvas>
  </div>
</hb-base-widget>
